import React, { useState, useEffect, useRef } from "react";
import { Outlet, NavLink, useNavigate, useLocation } from "react-router-dom";
import Login from "./Login";
import "../App.css";
import api from "../api.js";

import wave from "../imgs/wave_logo.svg";
import exit from "../imgs/exit_green.svg";
import lupa from "../imgs/lupa.svg";
import waveText from "../imgs/waveText.svg";
import defaultPfp from "../imgs/defaultPfp.svg";
import menu from "../imgs/menu.svg";

export default function Root() {
  const navigate = useNavigate();
  const location = useLocation();
  const isLoginPage = /^\/login\/?$/.test(location.pathname);

  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [partnerToSearch, setPartnerToSearch] = useState("");
  const [openExitModal, setOpenExitModal] = useState(false);
  const [customPfpLink, setCustomPfpLink] = useState("");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [theme, setTheme] = useState(() => localStorage.getItem("wave-theme") || "light");

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("wave-theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  useEffect(() => {
    if (isLoginPage) {
      setMe(null);
      setLoading(false);
      return;
    }

    const init = async () => {
      try {
        const res = await api.get("/api/auth/me");
        setMe(res.data);
      } catch {
        setMe(null);
      } finally {
        setLoading(false);
      }
    };

    init();
  }, [isLoginPage]);

  const handleLogin = async () => {
    try {
      const res = await api.get("/api/auth/me");
      setMe(res.data);
      navigate("/me");
    } catch {
      setMe(null);
    }
  };

  const handleLogout = async () => {
    try {
      localStorage.clear();
      await api.post("/api/auth/logout");
    } catch (e) {
      console.error("Ошибка выхода", e);
    }
    setMe(null);
    navigate("/login");
    setOpenExitModal(false);
  };

  const handleSearchByCode = (e) => {
    e.preventDefault();
    if (!partnerToSearch.trim()) return;
    navigate(`/partners?code=${partnerToSearch.trim()}`);
    setPartnerToSearch("");
  };

  const menuRef = useRef(null);
  const menuButtonRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        mobileMenuOpen &&
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        menuButtonRef.current &&
        !menuButtonRef.current.contains(event.target)
      ) {
        setMobileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [mobileMenuOpen]);

  if (loading) return null;

  if (!me || isLoginPage) return <Login onLogin={handleLogin} />;

  const role = me?.userInfo?.role;
  return (
    <div className="screenSize">
      <div className="mainDiv">
        {mobileMenuOpen && (
          <div className="menuUnfold" ref={menuRef}>
            <div className="navlinksMobile">
              {(me?.tabs || []).map((tab) => (
                <NavLink
                  key={tab.key}
                  to={`/${tab.key}`}
                  className={`menuUnfold-link tab-${tab.key}`}
                >
                  <p className="tab-titleMobile">{tab.title}</p>
                </NavLink>
              ))}
              {!(me?.tabs || []).some((tab) => tab.key === 'templates') && (
                <NavLink to="/templates" className="menuUnfold-link tab-templates">
                  <p className="tab-titleMobile">Шаблоны</p>
                </NavLink>
              )}
              {!(me?.tabs || []).some((tab) => tab.key === 'campaigns') && (
                <NavLink to="/campaigns" className="menuUnfold-link tab-campaigns">
                  <p className="tab-titleMobile">Рассылки</p>
                </NavLink>
              )}
              {!(me?.tabs || []).some((tab) => tab.key === 'reports') && (
                <NavLink to="/reports" className="menuUnfold-link tab-reports">
                  <p className="tab-titleMobile">Отчёты</p>
                </NavLink>
              )}
              <NavLink to="/me" className={"menuUnfold-link"}>
                Мой профиль
              </NavLink>
              <button
                type="button"
                className="theme-toggle theme-toggle-mobile"
                onClick={toggleTheme}
              >
                {theme === "dark" ? "☀ Светлая тема" : "☾ Тёмная тема"}
              </button>
            </div>
            <div className="waveTextMobile">
              <img src={waveText} alt="Wave" />
            </div>
          </div>
        )}
        <div className="header">
          <img src={wave} className="waveLogoTop" />
          <div className="rightSideTop">
            {role === "Админ" && (
              <>
                <div className="partnerSearchBar">
                  <input
                    placeholder="Поиск партнера"
                    value={partnerToSearch}
                    onChange={(e) => setPartnerToSearch(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handleSearchByCode(e);
                    }}
                  />
                  <button className="searchBtn" onClick={handleSearchByCode}>
                    <img src={lupa} alt="Поиск" />
                  </button>
                </div>
                {error && <p className="error">{error}</p>}
              </>
            )}

            <NavLink to="/me">
              <div className="me">
                <img src={customPfpLink || defaultPfp} className="userPic" />
                <p>{me?.userInfo?.name || me?.userInfo?.login}</p>
              </div>
            </NavLink>

            <button className="logOut" onClick={() => setOpenExitModal(true)}>
              <img src={exit} alt="Выйти" />
            </button>
            <button
              ref={menuButtonRef}
              className="menu"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <img src={menu} />
            </button>
          </div>
        </div>

        <div className="appWrapper">
          <div className="app-container">
            <div className="sidebar">
              <div className="navlinks">
                {(me?.tabs || []).map((tab) => (
                  <NavLink
                    key={tab.key}
                    to={`/${tab.key}`}
                    className={`sidebar-link tab-${tab.key}`}
                  >
                    <p className="tab-title">{tab.title}</p>
                  </NavLink>
                ))}
                {!(me?.tabs || []).some((tab) => tab.key === 'templates') && (
                  <NavLink
                    to="/templates"
                    className="sidebar-link tab-templates"
                  >
                    <p className="tab-title">Шаблоны</p>
                  </NavLink>
                )}
                {!(me?.tabs || []).some((tab) => tab.key === 'campaigns') && (
                  <NavLink
                    to="/campaigns"
                    className="sidebar-link tab-campaigns"
                  >
                    <p className="tab-title">Рассылки</p>
                  </NavLink>
                )}
                {!(me?.tabs || []).some((tab) => tab.key === 'reports') && (
                  <NavLink
                    to="/reports"
                    className="sidebar-link tab-reports"
                  >
                    <p className="tab-title">Отчёты</p>
                  </NavLink>
                )}
              </div>
              <div className="sidebar-footer">
                <button
                  type="button"
                  className="theme-toggle sidebar-theme-toggle"
                  onClick={toggleTheme}
                  title={theme === "dark" ? "Светлая тема" : "Тёмная тема"}
                >
                  <span className="theme-toggle-icon">{theme === "dark" ? "☀" : "☾"}</span>
                  <span>{theme === "dark" ? "Светлая тема" : "Тёмная тема"}</span>
                </button>
                <div className="waveText">
                  <img src={waveText} alt="Wave" />
                </div>
              </div>
            </div>

            <div className="main-content">
              <Outlet context={{ me, setOpenExitModal }} />
            </div>
          </div>
        </div>
      </div>

      {openExitModal && (
        <div className="modalOverlay">
          <div className="modalExit">
            <div className="exitModalTop">
              <h3>Вы уверены, что хотите выйти?</h3>
              <button onClick={() => setOpenExitModal(false)}></button>
            </div>
            <div className="buttonsModalExit">
              <button className="exitButton" onClick={handleLogout}>
                Да, выйти
              </button>
              <button
                className="cancelExit"
                onClick={() => setOpenExitModal(false)}
              >
                Отмена
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}